import { useEffect, useState } from "react";
import { SelectFormGroup } from "~/styles/FormGroup";
import api from "~/adapters/api";
import SelectInput from "~/shared/SelectInput";
import Spinner from "~/shared/Spinner";

type CitySelectProps = {
    name: string;
    label?: string;
    onChange: (name: string, value: string) => void;
    cities?: { value: string; label: string }[];
    stateId?: string;
    value?: string;
    error?: string;
    placeholder?: string;
    required?: boolean;
};

const CitySelect = ({ name, placeholder, label, onChange, cities, stateId, value, required = false, error = "" }: CitySelectProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [options, setOptions] = useState(cities ?? []);

    useEffect(() => {
        if (!cities) {
            setLoading(true);
            api.location.city({ stateId: parseInt(stateId) })
                .then(res => setOptions(res.entities.map(c => ({ label: c.cidade, value: c.id_cidades }))))
                .finally(() => setLoading(false));
        }
    }, [cities, stateId]);

    return (
        <SelectFormGroup className="form-group">
            {label ? <label htmlFor={name}>{label}{required ? " *" : ""}</label> : ""}
            {loading ? (
                <Spinner />
            ) : (
                <SelectInput
                    placeholder={placeholder}
                    name={name}
                    options={options}
                    className="form-control"
                    onChange={onChange}
                    value={value}
                    required={required}
                />
            )}
            {error ? <span className="field-error small">{error}</span> : ""}
        </SelectFormGroup>
    );
};

export default CitySelect;
